/**
 * Dashboard live preview of a page form (16 October 2026). The dashboard sends the draft as a
 * config (the same handshake as the chat preview); the form runs without network: nothing is
 * sent, no lead is created, and "Take me to WhatsApp" shows the message instead of opening it.
 */
import { useEffect, useState } from "preact/hooks";
import {
  isPreviewMessage,
  PREVIEW_PARENT_ORIGINS,
  PREVIEW_SOURCE,
  type MessageTemplate,
  type WidgetConfigResponse,
} from "@wapadesk/schema";
import { FormPage } from "./FormPage";

export function FormPreview({ apiOrigin }: { apiOrigin: string }) {
  const [payload, setPayload] = useState<
    { config: WidgetConfigResponse; template?: Partial<MessageTemplate> } | undefined
  >();
  useEffect(() => {
    const handler = (ev: MessageEvent) => {
      if (!(PREVIEW_PARENT_ORIGINS as readonly string[]).includes(ev.origin)) return;
      if (!isPreviewMessage(ev.data) || ev.data.type !== "preview") return;
      setPayload({
        config: ev.data.payload.config as WidgetConfigResponse,
        ...(ev.data.payload.template
          ? { template: ev.data.payload.template as Partial<MessageTemplate> }
          : {}),
      });
    };
    window.addEventListener("message", handler);
    window.parent.postMessage({ source: PREVIEW_SOURCE, type: "ready", payload: {} }, "*");
    return () => window.removeEventListener("message", handler);
  }, []);
  if (!payload?.config.form)
    return (
      <main class="bp center" aria-busy="true">
        <div class="spinner" aria-label="Loading" />
      </main>
    );
  return (
    <FormPage
      key={JSON.stringify(payload.config.form.schema).length}
      clinicRef={payload.config.clinicId}
      formId={payload.config.form.formId}
      apiOrigin={apiOrigin}
      preview={payload}
    />
  );
}
